import axios from "axios";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import { PDA_PREFIX } from "../../global/constants";
import { cancelScheduleFollows } from "../schedule-activity-services/scheduleFollowRegistry";

import {
  GET_ERRORS,
  DELETE_SCENARIO_REQUEST,
  DELETE_SCENARIO_SUCCESS,
  DELETE_SCENARIO_ERROR,
  GET_CHANCE_OF_SUCCESS_REQUEST,
  GET_CHANCE_OF_SUCCESS_SUCCESS,
  GET_CHANCE_OF_SUCCESS_ERROR,
  GENERATE_SCHEDULE_REQUEST,
  GENERATE_SCHEDULE_SUCCESS,
  GENERATE_SCHEDULE_ERROR,
  GET_SCENARIOS_REQUEST,
  GET_SCENARIOS_SUCCESS,
  GET_SCENARIOS_ERROR,
  GET_SCENARIOS_SUCCESS_AND_SET_ACTIVE_SCENARIO,
  GET_SCENARIO_REQUEST,
  GET_SCENARIO_SUCCESS,
  GET_SCENARIO_ERROR,
  UPDATE_SCENARIO_REQUEST,
  UPDATE_SCENARIO_SUCCESS,
  UPDATE_SCENARIO_ERROR,
  CLEAR_CURRENT_SCENARIO,
  GET_SCENARIO_METRIC_REQUEST,
  GET_SCENARIO_METRIC_SUCCESS,
  SCENARIO_USAGES_STALE_UPDATED,
  GET_SCENARIO_METRIC_ERROR,
  SET_CURRENT_SCENARIO,
  UPDATE_SCENARIOS_REQUEST,
  UPDATE_SCENARIOS_SUCCESS,
  UPDATE_SCENARIOS_ERROR,
  COPY_SCENARIO_REQUEST,
  COPY_SCENARIO_SUCCESS,
  COPY_SCENARIO_ERROR,
  CREATE_SCENARIO_REQUEST,
  CREATE_SCENARIO_SUCCESS,
  CREATE_SCENARIO_ERROR,
  UPDATE_CURRENT_SCENARIO_REQUEST,
  UPDATE_CURRENT_SCENARIO_SUCCESS,
  UPDATE_CURRENT_SCENARIO_ERROR,
  UPDATE_SCENARIO_STATE,
  MARK_FEVER_CHART_SUCCESS,
  GET_ALL_APPROVED_SCENARIOS_SUCCESS,
  GET_ALL_APPROVED_SCENARIOS_ERROR,
  GET_ALL_APPROVED_SCENARIOS_REQUEST,
  CONVERT_TO_AUTOMATIC_REQUEST,
  CONVERT_TO_AUTOMATIC_SUCCESS,
  CONVERT_TO_AUTOMATIC_ERROR,
  GET_SWAP_SCENARIOS_REQUEST,
  GET_SWAP_SCENARIOS_SUCCESS,
  GET_SWAP_SCENARIOS_ERROR,
  GET_EVM_REQUEST,
  GET_EVM_SUCCESS,
  GET_EVM_ERROR,
  UPDATE_DOR_WITH_CONFORM_PROGRESS_SUCCESS,
  UPDATE_DATE_OF_REVIEW_SUCCESS,
  GET_SUB_CODES_OF_PROJECT,
  GET_PORTFOLIO_SCENARIOS_REQUEST,
  GET_PORTFOLIO_SCENARIOS_SUCCESS,
  GET_PORTFOLIO_SCENARIOS_ERROR,
  DELETE_PORTFOLIO_SCENARIO_REQUEST,
  DELETE_PORTFOLIO_SCENARIO_SUCCESS,
  DELETE_PORTFOLIO_SCENARIO_ERROR,
  UPDATE_PORTFOLIO_SCENARIO_REQUEST,
  UPDATE_PORTFOLIO_SCENARIO_SUCCESS,
  UPDATE_PORTFOLIO_SCENARIO_ERROR,
  APPROVE_PORTFOLIO_SCENARIO,
  REJECT_PORTFOLIO_SCENARIO,
  GET_PORTFOLIO_SCENARIO_NAME,
  SET_ACTIVE_SCENARIO,
} from "../types";
import { logout } from "../security-services/SecurityActions";
import logoutforSpecificErrorCodes from "../../securityUtils/LogoutUtils";
import {
  updateScheduleActivitiesSuccess,
  followScheduleUpdateJob,
  regenerateScheduleInBackground,
} from "../schedule-activity-services/scheduleActivityActions";
import {
  isGenerativeSchedulingExperimentalEnabled,
  buildGenerativeSchedulingExperimentalPath,
} from "../utils-services/utilsActions";

export const createScenarioRequest = () => ({ type: CREATE_SCENARIO_REQUEST });

export const createScenarioSuccess = (scenario) => ({
  type: CREATE_SCENARIO_SUCCESS,
  payload: scenario,
});

export const createScenarioError = (err) => ({
  type: CREATE_SCENARIO_ERROR,
  payload: err,
});

export const updateScenarioRequest = () => ({ type: UPDATE_SCENARIO_REQUEST });

export const updateScenarioSuccess = (scenario) => ({
  type: UPDATE_SCENARIO_SUCCESS,
  payload: scenario,
});
export const updateScenarioError = (err) => ({
  type: UPDATE_SCENARIO_ERROR,
  payload: err,
});

export const updateCurrentScenarioRequest = () => ({
  type: UPDATE_CURRENT_SCENARIO_REQUEST,
});
export const updateCurrentScenarioSuccess = (scenario) => ({
  type: UPDATE_CURRENT_SCENARIO_SUCCESS,
  payload: scenario,
});
export const updateCurrentScenarioError = (err) => ({
  type: UPDATE_CURRENT_SCENARIO_ERROR,
  payload: err,
});

const updateDorWithConformProgressSuccess = (data) => ({
  type: UPDATE_DOR_WITH_CONFORM_PROGRESS_SUCCESS,
  payload: data,
});

const updateDateOfReviewSuccess = (dateOfReview) => ({
  type: UPDATE_DATE_OF_REVIEW_SUCCESS,
  payload: dateOfReview,
});

export const copyScenarioRequest = () => ({ type: COPY_SCENARIO_REQUEST });

export const copyScenarioSuccess = (scenario) => ({
  type: COPY_SCENARIO_SUCCESS,
  payload: scenario,
});
export const copyScenarioError = (err) => ({
  type: COPY_SCENARIO_ERROR,
  payload: err,
});

export const updateScenariosRequest = () => ({
  type: UPDATE_SCENARIOS_REQUEST,
});

export const updateScenariosSuccess = (scenarios) => ({
  type: UPDATE_SCENARIOS_SUCCESS,
  payload: scenarios,
});
export const updateScenariosError = (err) => ({
  type: UPDATE_SCENARIOS_ERROR,
  payload: err,
});

export const generateScheduleRequest = () => ({
  type: GENERATE_SCHEDULE_REQUEST,
});

export const generateScheduleSuccess = () => ({
  type: GENERATE_SCHEDULE_SUCCESS,
  payload: "success",
});
export const generateScheduleError = (err) => ({
  type: GENERATE_SCHEDULE_ERROR,
  payload: err,
});

export const getScenariosRequest = () => ({ type: GET_SCENARIOS_REQUEST });

export const getScenariosSuccess = (scenarios) => ({
  type: GET_SCENARIOS_SUCCESS,
  payload: scenarios,
});
export const getScenariosError = (err) => ({
  type: GET_SCENARIOS_ERROR,
  payload: err,
});

export const getScenariosSuccessAndSetActiveScenario = (data) => ({
  type: GET_SCENARIOS_SUCCESS_AND_SET_ACTIVE_SCENARIO,
  payload: data,
});

export const getScenarioRequest = () => ({ type: GET_SCENARIO_REQUEST });

export const getScenarioSuccess = (scenario) => ({
  type: GET_SCENARIO_SUCCESS,
  payload: scenario,
});
export const getScenarioError = (err) => ({
  type: GET_SCENARIO_ERROR,
  payload: err,
});

export const getScenarioMetricRequest = () => ({
  type: GET_SCENARIO_METRIC_REQUEST,
});

export const getScenarioMetricSuccess = (scenario) => ({
  type: GET_SCENARIO_METRIC_SUCCESS,
  payload: scenario,
});
export const getScenarioMetricError = (err) => ({
  type: GET_SCENARIO_METRIC_ERROR,
  payload: err,
});

export const deleteScenarioRequest = () => ({
  type: DELETE_SCENARIO_REQUEST,
});

export const deleteScenarioSuccess = (id) => ({
  type: DELETE_SCENARIO_SUCCESS,
  payload: id,
});
export const deleteScenarioError = (err) => ({
  type: DELETE_SCENARIO_ERROR,
  payload: err,
});

export const updateScenarioState = (isSync) => ({
  type: UPDATE_SCENARIO_STATE,
  payload: isSync,
});

export const getChanceOfSuccessRequest = () => ({
  type: GET_CHANCE_OF_SUCCESS_REQUEST,
});

export const getChanceOfSuccessSuccess = (payload) => ({
  type: GET_CHANCE_OF_SUCCESS_SUCCESS,
  payload: payload,
});
export const getChanceOfSuccessError = (err) => ({
  type: GET_CHANCE_OF_SUCCESS_ERROR,
  payload: err,
});

export const markFeverChartSuccess = (scenario) => ({
  type: MARK_FEVER_CHART_SUCCESS,
  payload: scenario,
});

export const getAllApprovedScenariosRequest = () => ({
  type: GET_ALL_APPROVED_SCENARIOS_REQUEST,
});

export const getAllApprovedScenariosSuccess = (data) => ({
  type: GET_ALL_APPROVED_SCENARIOS_SUCCESS,
  payload: data,
});

export const getAllApprovedScenariosError = (error) => ({
  type: GET_ALL_APPROVED_SCENARIOS_ERROR,
  payload: error,
});

const getSwapScenariosRequest = () => ({ type: GET_SWAP_SCENARIOS_REQUEST });

const getSwapScenariosSuccess = (scenarios) => ({
  type: GET_SWAP_SCENARIOS_SUCCESS,
  payload: scenarios,
});

const getSwapScenariosError = (err) => ({
  type: GET_SWAP_SCENARIOS_ERROR,
  payload: err,
});

const convertToAutomaticRequest = () => ({
  type: CONVERT_TO_AUTOMATIC_REQUEST,
});

const convertToAutomaticSuccess = (data) => ({
  type: CONVERT_TO_AUTOMATIC_SUCCESS,
  payload: data,
});

const convertToAutomaticError = (error) => ({
  type: CONVERT_TO_AUTOMATIC_ERROR,
  payload: error,
});

const getEVMRequest = () => ({
  type: GET_EVM_REQUEST,
});

const getEVMSuccess = (data) => ({
  type: GET_EVM_SUCCESS,
  payload: data,
});

const getEVMError = (data) => ({
  type: GET_EVM_ERROR,
  payload: data,
});

const getPortfolioScenariosRequest = () => ({
  type: GET_PORTFOLIO_SCENARIOS_REQUEST,
});

const getPortfolioScenariosSuccess = (data) => ({
  type: GET_PORTFOLIO_SCENARIOS_SUCCESS,
  payload: data,
});

const getPortfolioScenariosError = (err) => ({
  type: GET_PORTFOLIO_SCENARIOS_ERROR,
  payload: err,
});

const deletePortfolioScenarioRequest = () => ({
  type: DELETE_PORTFOLIO_SCENARIO_REQUEST,
});

const deletePortfolioScenarioSuccess = (id) => ({
  type: DELETE_PORTFOLIO_SCENARIO_SUCCESS,
  payload: id,
});

const deletePortfolioScenarioError = (err) => ({
  type: DELETE_PORTFOLIO_SCENARIO_ERROR,
  payload: err,
});

const updatePortfolioScenarioRequest = () => ({
  type: UPDATE_PORTFOLIO_SCENARIO_REQUEST,
});

const updatePortfolioScenarioSuccess = (data) => ({
  type: UPDATE_PORTFOLIO_SCENARIO_SUCCESS,
  payload: data,
});

const updatePortfolioScenarioError = (err) => ({
  type: UPDATE_PORTFOLIO_SCENARIO_ERROR,
  payload: err,
});

// Fect actions

export const add = (scenarioForm, projectId, navigate) => async (dispatch) => {
  dispatch(createScenarioRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/add/${projectId}/test`,
      scenarioForm
    );
    if (isGenerativeSchedulingExperimentalEnabled()) {
      navigate(
        buildGenerativeSchedulingExperimentalPath({
          projectId,
          scenarioId: res.data.id,
          structureId: res.data.structureId,
        })
      );
    } else {
      navigate(
        `/preparation/view/gantt/${projectId}/${res.data.id}/${res.data.structureId}`
      );
    }
    toast.success("Schedule has been generated");
    dispatch(fetchGetScenariosByProjectId(projectId, res.data.id));
    return res.data;
  } catch (err) {
    dispatch(createScenarioError(err.response.data));
    if (err.message) {
      toast.warning(err.response.data);
    } else if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    } else {
      toast.error(err);
    }
  }
};

// todo : rename the method since it is
export const addScenarioToProject = (
  scenarioForm,
  projectId,
  navigate
) => async (dispatch) => {
  dispatch(createScenarioRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/add/${projectId}`,
      scenarioForm
    );
    if (navigate) {
      if (isGenerativeSchedulingExperimentalEnabled()) {
        navigate(
          buildGenerativeSchedulingExperimentalPath({
            projectId,
            scenarioId: res.data.id,
            structureId: res.data.structure?.id,
          })
        );
      } else {
        navigate(
          `/preparation/view/gantt/${projectId}/${res.data.id}/${res.data.structure.id}`
        );
      }
    }
    toast.success("Schedule has been generated");
    dispatch(createScenarioSuccess(res.data));
    return res.data;
  } catch (err) {
    dispatch(createScenarioError(err.response.data));
    if (err.message) {
      toast.warning(err.response.data);
    } else if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    } else {
      toast.error(err);
    }
  }
};

export const setScenarioDimensions = (
  projectId,
  scenarioId,
  structureId,
  navigate
) => async (dispatch) => {
  dispatch(generateScheduleRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/set-dimensions/${scenarioId}`
    );
    dispatch(generateScheduleSuccess(res.data));
    navigate(
      `/preparation/view/metrics/${projectId}/${scenarioId}/${structureId}`
    );
    toast.success("Schedule has been generated");
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.warning(err.response.data);
    dispatch(generateScheduleError());
  }
};

export const updateScenario = (scenario) => async (dispatch) => {
  dispatch(updateScenarioRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/scenario/update`, scenario);
    dispatch(updateScenarioSuccess(res.data));
  } catch (err) {
    dispatch(updateScenarioError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.warning("Name already taken");
  }
};

export const updateCurrentScenario = (scenario) => async (dispatch) => {
  dispatch(updateCurrentScenarioRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/scenario/update`, scenario);
    dispatch(updateCurrentScenarioSuccess(res.data));
    toast.success("Update done on scenario !");
    return true;
  } catch (err) {
    dispatch(updateCurrentScenarioError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    return false;
  }
};

/**
 * Shared handler for ConformProgressDTO responses (PUT /conform-progress, PATCH /date-of-review).
 * The new Date of Review is saved once the request answered: the scenario shows it at once and
 * `isUpdating` ends. The usages regeneration it entails runs on in the background, shown by the
 * "Updating usages" card (PRE-066 review I1). Returns that regeneration (resolves true / false,
 * never rejects); the dialogs do not wait for it.
 *
 * @param {ConformProgressDTO} dto - { scenarioId, dateOfReview, progressDTOs,
 *   regenerationStatus, regenerationJobId, regenerationEtaSeconds }
 */
export const handleConformProgressResponse = (dto) => (dispatch) => {
  dispatch(updateDorWithConformProgressSuccess(dto));
  const {
    regenerationStatus: status,
    regenerationJobId: jobId,
    regenerationEtaSeconds: etaSeconds,
    scenarioId,
  } = dto;
  const regeneration =
    status === "STARTED" && jobId
      ? dispatch(followScheduleUpdateJob(scenarioId, jobId, etaSeconds ?? null))
      : // ALREADY_RUNNING (the running job predates the new Date of Review, so only a
        // resubmission applies it; the async resubmission waits out the job holding the lock,
        // also another user's), kill switch off, job not queued, or an older backend.
        dispatch(regenerateScheduleInBackground(scenarioId));
  return Promise.resolve(regeneration).catch(() => false);
};

export const updateDateOfReviewWithConformProgress = (dto) => async (
  dispatch,
  getState
) => {
  dispatch(updateCurrentScenarioRequest());
  try {
    const res = await axios.put(
      `${PDA_PREFIX}/scenario/update/conform-progress`,
      dto
    );
    dispatch(handleConformProgressResponse(res.data));
    // The dialog that asked may belong to a scenario no longer open by now.
    if (String(getState()?.scenario?.item?.id) === String(dto.scenarioId)) {
      toast.success(
        i18n.t("projectReviewDateModal.successMessage", { reviewDate: res.data?.dateOfReview ?? dto.dateOfReview })
      );
    }
  } catch (err) {
    dispatch(updateCurrentScenarioError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const copyScenario = (scenarioId, bumpType) => async (dispatch) => {
  // Dispatch the request marker so any UI relying on it (e.g. "copy in
  // progress" badges) still ticks. The shared async-job modal (bound to
  // state.scenarioCopy) handles success/error feedback + per-scenario status;
  // it also dispatches copyScenarioSuccess on ALL_COMPLETED via the
  // COPY_SCENARIO_SUCCESS action type, so the scenario list reducer stays in
  // sync without us doing anything here.
  // bumpType: "MAJOR" or "MINOR" — drives the version bump on the copy.
  // Default is MINOR (preserve major, minor++).
  dispatch(copyScenarioRequest());
  const { startScenarioCopy } = await import(
    "../scenario-copy-services/scenarioCopyActions"
  );
  try {
    await dispatch(startScenarioCopy(scenarioId, bumpType));
  } catch {
    dispatch(copyScenarioError());
    // Error surface is the progress modal's red panel; no toast needed.
  }
};

export const updateScenarios = (scenario) => async (dispatch) => {
  dispatch(updateScenariosRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/scenario/update`, scenario);
    //console.log(res.data);
    dispatch(updateScenariosSuccess(res.data));
  } catch (err) {
    dispatch(updateScenarioError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const updateDateOfReview = (scenarioId, dateOfReview) => async (
  dispatch
) => {
  dispatch(updateCurrentScenarioRequest());
  try {
    const res = await axios.patch(
      `${PDA_PREFIX}/scenario/update/${scenarioId}/date-of-review`,
      JSON.stringify(dateOfReview),
      { headers: { "Content-Type": "application/json" } }
    );
    // A ConformProgressDTO: the date is saved, the regeneration goes on in the background
    // (not awaited: the dialog closes now).
    dispatch(handleConformProgressResponse(res.data));
  } catch (err) {
    dispatch(updateCurrentScenarioError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    throw err;
  }
};

/**
 * The activation workflow gate refuses `PUT /scenario/{id}/APPROVED` with a 409
 * whose plain-text body says exactly why activation is blocked and what is
 * missing (workflow not launched / still pending / rejected). Returns that
 * reason, or null when the error is anything else.
 */
export const getScenarioActivationBlockedReason = (err) => {
  const reason = err?.response?.data;
  return err?.response?.status === 409 && typeof reason === "string" && reason
    ? reason
    : null;
};

export const toastScenarioActivationBlocked = (reason) =>
  toast.error(reason, { autoClose: 12000 });

export const updateByIdAndStatus = (scenarioId, scenarioStatus) => async (
  dispatch
) => {
  //dispatch(updateScenariosRequest());

  try {
    const res = await axios.put(
      `${PDA_PREFIX}/scenario/${scenarioId}/${scenarioStatus}`
    );
    dispatch(updateScenariosSuccess(res.data));
    toast.info("Scenario " + scenarioId + " is now " + scenarioStatus);
    return true;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }

    dispatch(updateScenariosError(err));
    const blockedReason = getScenarioActivationBlockedReason(err);
    if (blockedReason) {
      toastScenarioActivationBlocked(blockedReason);
    } else if (err.response.status === 400) {
      toast.error("This scenario is empty and cannot be Approved.");
    } else {
      toast.error("Oops! Issue while approving or rejecting your scenario.");
    }
    // Callers gate their success side effects (e.g. navigation) on this.
    return false;
  }
};

export const updateAllByIdsAndStatus = (scenarioIds, scenarioStatus) => async (
  dispatch
) => {
  dispatch(updateScenariosRequest());

  try {
    const res = await axios.put(
      `${PDA_PREFIX}/scenario/bulk/${scenarioStatus}`,
      scenarioIds
    );
    dispatch(updateScenariosSuccess(res.data));
    toast.success(`${scenarioIds.length} scenario(s) ${scenarioStatus.toLowerCase()} successfully.`);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }

    dispatch(updateScenariosError(err));
    toast.error("Failed to update scenarios.");
  }
};

// The portfolio-wide list (projects grid) and a single project's list
// (scenarios view) both land in `state.scenario.items`. `all-portfolio` is
// slow on large portfolios, so opening a project right after the projects
// grid mounted let its late response overwrite the project's scenarios.
// Only the most recent list request is allowed to write the slice.
let scenarioListRequestId = 0;
const isStaleScenarioListRequest = (requestId) =>
  requestId !== scenarioListRequestId;

export const fetchGetScenarios = () => async (dispatch) => {
  const requestId = ++scenarioListRequestId;
  dispatch(getScenariosRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/all-portfolio`);
    if (isStaleScenarioListRequest(requestId)) return;
    dispatch(getScenariosSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    if (isStaleScenarioListRequest(requestId)) return;
    dispatch(getScenariosError(err.message));
  }
};

export const fetchGetScenariosByProjectId = (
  projectId,
  currentScenarioId,
  isSilent = false
) => async (dispatch) => {
  const requestId = ++scenarioListRequestId;
  !isSilent && dispatch(getScenariosRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/all/${projectId}`);
    if (!isStaleScenarioListRequest(requestId)) {
      dispatch(
        getScenariosSuccessAndSetActiveScenario({
          items: res.data,
          currentScenarioId,
        })
      );
    }
    return res.data;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    if (!isStaleScenarioListRequest(requestId)) {
      dispatch(getScenariosError(err.message));
    }
    return null;
  }
};

export const clearCurrentScenario = () => async (dispatch) => {
  cancelScheduleFollows();
  dispatch({
    type: CLEAR_CURRENT_SCENARIO,
    payload: {},
  });
};

export const setCurrentScenario = (scenario) => async (dispatch) => {
  cancelScheduleFollows({ exceptScenarioId: scenario?.id });
  dispatch({
    type: SET_CURRENT_SCENARIO,
    payload: scenario,
  });
};

export const fetchGetScenariosByProjectStatus = (projectStatus) => async (
  dispatch
) => {
  const requestId = ++scenarioListRequestId;
  dispatch(getScenariosRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/scenario/all-portfolio/${projectStatus}`
    );
    if (isStaleScenarioListRequest(requestId)) return;
    dispatch(getScenariosSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    if (isStaleScenarioListRequest(requestId)) return;
    dispatch(getScenariosError(err.message));
  }
};

export const fetchGetScenario = (scenarioId, silent = false) => async (
  dispatch
) => {
  !silent && dispatch(getScenarioRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/${scenarioId}`);
    dispatch(getScenarioSuccess(res.data));
    return Promise.resolve(res.data);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getScenarioError(err));
    return Promise.resolve(null);
  }
};

// SPEC-0022: re-reads the real freshness flag of the loaded scenario (the
// backend stamps usages at job START, so an edit made during the run keeps it
// stale). A failed read leaves the flag as it was: stale wins.
// onlyStale: the post-write recheck (cascaded rows) may grey the scenario
// but never turn it fresh; only the end of an Update Usages job does that.
export const refreshScenarioUsagesStale = (scenarioId, { onlyStale = false } = {}) => async (dispatch) => {
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/${scenarioId}`);
    const usagesStale = res.data?.usagesStale === true;
    if (onlyStale && !usagesStale) return usagesStale;
    dispatch({
      type: SCENARIO_USAGES_STALE_UPDATED,
      payload: { scenarioId, usagesStale },
    });
    return usagesStale;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) dispatch(logout());
  }
};

export const getScenarioForMetric = (scenarioId) => async (dispatch) => {
  dispatch(getScenarioMetricRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/${scenarioId}`);
    dispatch(getScenarioMetricSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getScenarioMetricError(err));
  }
};

export const deleteScenario = (id) => async (dispatch) => {
  // Route through the async WebSocket flow — the shared progress dialog (bound
  // to state.scenarioDelete) handles user feedback, and the thunk dispatches
  // DELETE_SCENARIO_SUCCESS on COMPLETED so the scenarioReducer drops the row
  // from the list exactly like the legacy synchronous path did.
  dispatch(deleteScenarioRequest());
  const { startScenarioDelete } = await import(
    "../scenario-delete-services/scenarioDeleteActions"
  );
  try {
    await dispatch(startScenarioDelete(id));
  } catch {
    dispatch(deleteScenarioError());
    // Error surface is the progress modal's red panel; no toast needed.
  }
};

export const generateSchedule = (id, navigate) => async (dispatch) => {
  dispatch(getScenarioRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/scenario/${id}/generate-schedule`
    );
    dispatch(getScenarioSuccess(res.data));
    navigate(`/process`);
    toast.success("Schedule has been successfully generated! Well done!");
  } catch (err) {
    dispatch(getScenarioError(err.message));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }

    navigate(`/preparation`);
    toast.error(
      "Nothing to worry about, issue is easy to fix! Contact support, they will help you in a few minutes..."
    );
  }
};

export const getChanceOfSuccess = (id) => async (dispatch) => {
  dispatch(getChanceOfSuccessRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/scenario/${id}/get-chance-of-success`
    );
    dispatch(getChanceOfSuccessSuccess(res.data));
  } catch (err) {
    dispatch(getChanceOfSuccessError(err.message));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const importScenarioByCSV = (file, projectId, restoring = false) => async (dispatch) => {
  try {
    if (restoring) await axios.post(`${PDA_PREFIX}/scenario/restore-csv/${projectId}`, file);
    else await axios.post(`${PDA_PREFIX}/scenario/import-csv/${projectId}`, file);
    toast.success("CSV file has been processed successfully.");
    return { success: true };
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }

    if (err.response.status === 504) {
      return {
        success: false,
        errorMessage:
          "The server did not respond in time. Please try again later.",
      };
    }

    const data = err.response.data;
    // Pass structured error object (with errors array) when present; otherwise fall back to a string
    const errorMessage =
      data && typeof data === "object" && Array.isArray(data.errors)
        ? data
        : data?.error || data || "Something went wrong";
    return { success: false, errorMessage };
  }
};

export const markFeverChart = (scenarioId) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/mark-fever-chart/${scenarioId}`
    );
    toast.success("Fever chart has been marked with data point");
    dispatch(markFeverChartSuccess(res.data));
  } catch (err) {
    if (err.message) {
      toast.warning("Couldn't apply data point into the fever chart");
    } else if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    } else {
      toast.error(err);
    }
  }
};

export const getAllApprovedScenarios = () => async (dispatch) => {
  dispatch(getAllApprovedScenariosRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/approved/all`);
    dispatch(getAllApprovedScenariosSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getAllApprovedScenariosError(err));
  }
};

export const convertToAutomatic = (scenarioId) => async (dispatch) => {
  // action left as a comment on purpose since fetching status is already handled outside of this function
  // dispatch(convertToAutomaticRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/${scenarioId}/convert-to-automatic`
    );
    dispatch(updateScheduleActivitiesSuccess(res.data.scheduleActivities));
    dispatch(convertToAutomaticSuccess(res.data));
    toast.success("Conversion done successfully !");
    return Promise.resolve();
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(
      "There was a problem during conversion, please contact support."
    );
    dispatch(convertToAutomaticError(err));
    return Promise.reject();
  }
};

export const getSwapScenarios = (scenarioId) => async (dispatch) => {
  dispatch(getSwapScenariosRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/scenario/swap-data/${scenarioId}`
    );
    dispatch(getSwapScenariosSuccess(res.data));
    return Promise.resolve(res.data);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }

    dispatch(getSwapScenariosError(err));
    toast.error("Something went wrong");
    return Promise.reject();
  }
};

export const updateScenarioStatus = (scenarioId, scenarioStatus) => async (
  dispatch
) => {
  try {
    await axios.put(`${PDA_PREFIX}/scenario/${scenarioId}/${scenarioStatus}`);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    const blockedReason = getScenarioActivationBlockedReason(err);
    if (blockedReason) {
      toastScenarioActivationBlocked(blockedReason);
    } else {
      toast.error("Something went wrong");
    }
    throw err;
  }
};

export const getEVM = (scenarioId) => async (dispatch) => {
  dispatch(getEVMRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/scenario/EVM/${scenarioId}`);
    dispatch(getEVMSuccess(res.data));
  } catch (err) {
    dispatch(getEVMError(err.message));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const getSubCodesOfProject = (scenarioId) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/scenario/sub-codes/${scenarioId}`
    );
    dispatch({
      type: GET_SUB_CODES_OF_PROJECT,
      payload: res.data,
    });
  } catch (err) {
    dispatch(getScenarioError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const getAllPortfolioScenariosWithData = () => async (dispatch) => {
  dispatch(getPortfolioScenariosRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/portfolio-scenario/all`);
    dispatch(getPortfolioScenariosSuccess(res.data));
  } catch (err) {
    dispatch(getPortfolioScenariosError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

// Conservative revert: copies the baseline portfolio scenario's
// assumptions JSON onto the active one and clears its `simulated` flag.
// The underlying schedule graph (activities/blocks/quantities/etc.) is
// intentionally NOT touched — see the backend service contract for the
// rationale. On success we refresh the portfolio-scenarios slice so the
// Compare modal / KPI bar reflect the new state.
export const revertPortfolioScenarioToBaseline =
  (activeId, baselineId) => async (dispatch) => {
    try {
      await axios.post(
        `${PDA_PREFIX}/portfolio-scenario/${activeId}/revert-to/${baselineId}`
      );
      await dispatch(getAllPortfolioScenariosWithData());
      toast.success("Reverted assumptions to baseline. Regenerate to apply.");
      return true;
    } catch (err) {
      toast.error("Failed to revert to baseline. Please try again.");
      return false;
    }
  };

export const deletePortfolioScenario = (id, onCascade) => async (dispatch) => {
  dispatch(deletePortfolioScenarioRequest());
  const endpointSuffix = onCascade ? `on-cascade/${id}` : `${id}`;
  try {
    await axios.delete(`${PDA_PREFIX}/portfolio-scenario/${endpointSuffix}`);
    dispatch(deletePortfolioScenarioSuccess(id));
  } catch (err) {
    dispatch(deletePortfolioScenarioError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const updatePortfolioScenario = (data) => async (dispatch) => {
  dispatch(updatePortfolioScenarioRequest());
  try {
    await axios.patch(`${PDA_PREFIX}/portfolio-scenario/update`, data);
    dispatch(updatePortfolioScenarioSuccess(data));
  } catch (err) {
    dispatch(updatePortfolioScenarioError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const approvePortfolioScenario = (id) => async (dispatch) => {
  dispatch(updatePortfolioScenarioRequest());
  try {
    await axios.patch(`${PDA_PREFIX}/portfolio-scenario/approve/${id}`);
    dispatch({ type: APPROVE_PORTFOLIO_SCENARIO, payload: id });
  } catch (err) {
    dispatch(updatePortfolioScenarioError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const rejectPortfolioScenario = (id) => async (dispatch) => {
  dispatch(updatePortfolioScenarioRequest());
  try {
    await axios.patch(`${PDA_PREFIX}/portfolio-scenario/reject/${id}`);
    dispatch({ type: REJECT_PORTFOLIO_SCENARIO, payload: id });
  } catch (err) {
    dispatch(updatePortfolioScenarioError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const getPortfolioScenarioName = () => async (dispatch) => {
  const res = await axios.get(`${PDA_PREFIX}/portfolio-scenario/approved/name`);
  dispatch({
    type: GET_PORTFOLIO_SCENARIO_NAME,
    payload: res.data,
  });
};

export const setActiveScenario = (scenarioId) => async (dispatch) => {
  dispatch({
    type: SET_ACTIVE_SCENARIO,
    payload: scenarioId,
  });
};

// ---------------------------------------------------------------------------
// Scenario approval workflow (Phase 1)
// ---------------------------------------------------------------------------

const handleApprovalError = (dispatch, err, fallback) => {
  if (logoutforSpecificErrorCodes(err)) dispatch(logout());
  const msg =
    (err && err.response && err.response.data && err.response.data.message) ||
    (err && err.response && err.response.data) ||
    fallback;
  toast.error(typeof msg === "string" ? msg : fallback);
};

export const launchApproval = (scenarioId, payload, projectId) => async (
  dispatch
) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/${scenarioId}/approval/launch`,
      payload
    );
    if (projectId) dispatch(fetchGetScenariosByProjectId(projectId, null, true));
    toast.success(
      res.data && res.data.approvalState === "APPROVED"
        ? i18n.t("scenario.approval.toastApproved")
        : i18n.t("scenario.approval.toastLaunched")
    );
    return res.data;
  } catch (err) {
    handleApprovalError(dispatch, err, i18n.t("scenario.approval.errLaunch"));
    throw err;
  }
};

export const approveScenario = (scenarioId, comment, projectId) => async (
  dispatch
) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/${scenarioId}/approval/approve`,
      { comment }
    );
    // Tell the grid's action cell to re-pull its "X/Y scopes" progress — the
    // scenario stays PENDING until every scope is approved, so the cell's own
    // fetch (keyed on approvalState) wouldn't otherwise re-run.
    document.dispatchEvent(
      new CustomEvent("approvalActionDone", { detail: { scenarioId } })
    );
    if (projectId) dispatch(fetchGetScenariosByProjectId(projectId, null, true));
    toast.success(
      res.data && res.data.approvalState === "APPROVED"
        ? i18n.t("scenario.approval.toastApproved")
        : i18n.t("scenario.approval.toastRecorded")
    );
    return res.data;
  } catch (err) {
    handleApprovalError(dispatch, err, i18n.t("scenario.approval.errApprove"));
    throw err;
  }
};

export const rejectScenario = (scenarioId, comment, projectId) => async (
  dispatch
) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/${scenarioId}/approval/reject`,
      { comment }
    );
    document.dispatchEvent(
      new CustomEvent("approvalActionDone", { detail: { scenarioId } })
    );
    if (projectId) dispatch(fetchGetScenariosByProjectId(projectId, null, true));
    toast.info(i18n.t("scenario.approval.toastRejected"));
    return res.data;
  } catch (err) {
    handleApprovalError(dispatch, err, i18n.t("scenario.approval.errReject"));
    throw err;
  }
};

export const cancelScenario = (scenarioId, projectId) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/${scenarioId}/approval/cancel`
    );
    document.dispatchEvent(
      new CustomEvent("approvalActionDone", { detail: { scenarioId } })
    );
    if (projectId) dispatch(fetchGetScenariosByProjectId(projectId, null, true));
    toast.info(i18n.t("scenario.approval.toastCancelled"));
    return res.data;
  } catch (err) {
    handleApprovalError(dispatch, err, i18n.t("scenario.approval.errCancel"));
    throw err;
  }
};

export const setManualApproval = (scenarioId, approved, projectId) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/scenario/${scenarioId}/approval/manual`,
      { approved }
    );
    document.dispatchEvent(
      new CustomEvent("approvalActionDone", { detail: { scenarioId } })
    );
    if (projectId) dispatch(fetchGetScenariosByProjectId(projectId, null, true));
    toast.info(
      approved
        ? i18n.t("scenario.approval.toastManualApproved")
        : i18n.t("scenario.approval.toastManualUnapproved")
    );
    return res.data;
  } catch (err) {
    handleApprovalError(dispatch, err, i18n.t("scenario.approval.errManual"));
    throw err;
  }
};

export const fetchApprovalStatus = (scenarioId) => async () => {
  const res = await axios.get(`${PDA_PREFIX}/scenario/${scenarioId}/approval`);
  return res.data;
};
